import React from 'react'
import { withStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import homeIcon from '../images/svg/home_icon.svg'

const styles = theme => ({
  noPropertyRoot: {
    width: '100%',
  },
  noPropFound: {
    maxWidth: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // 100vh is for viewport height,
    // 64px is header height,
    // 64px is filter-bar height
    // 60px is for maintaining scroll whenever no-property component appears
    // 42px is the padding sorrounding the parent of loader/no-result section / property result
    height: 'calc( 100vh - (64px + 64px + 60px + 42px))',
    minHeight: '428px',
    [theme.breakpoints.down('1024')]: {
      minHeight: '340px',
    },
    [theme.breakpoints.down('768')]: {
      // 100vh is for viewport height,
      // 48px is header height,
      // 64px is filter-bar height
      // 160px is footer height
      // 42px is the padding sorrounding the parent of loader/no-result section / property result
      height: 'calc( 100vh - (48px + 64px + 160px + 42px))',
      minHeight: '428px',
    },
    [theme.breakpoints.down('600')]: {
      minHeight: '308px',
    },
    [theme.breakpoints.down('480')]: {
      // 100vh is for viewport height,
      // 48px is header height,
      // 118px is filter-bar height
      // 160px is footer height
      height: 'calc( 100vh - (48px + 118px + 160px))',
      marginTop: '-20px',
      marginBottom: '-20px',
    },
  },
  noPropContent: {
    width: '350px',
    height: '350px',
    backgroundColor: 'rgba(29, 187, 176, 0.07)',
    borderRadius: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 18px',
    [theme.breakpoints.down('1024')]: {
      width: '298px',
      height: '298px',
    },
    [theme.breakpoints.down('768')]: {
      width: '350px',
      height: '350px',
    },
    [theme.breakpoints.down('600')]: {
      width: '250px',
      height: '250px',
    },
    '& h2': {
      margin: '15px 0 8px',
      fontSize: '15px',
      fontWeight: '500',
      color: '#231f20',
    },
    '& p': {
      fontSize: '13px',
      lineHeight: '1.38',
      color: '#888888',
    },
  },
})

class NoPropertyFound extends React.Component {
  render() {
    const { classes, title, msg = '' } = this.props
    return (
      <div className={classes.noPropertyRoot}>
        <div className={classes.noPropFound}>
          <div className={classes.noPropContent}>
            <div>
              <img src={homeIcon} alt={'homeIcon'} />
            </div>
            <Typography variant="title">{title || 'No Properties Found!'}</Typography>
            <Typography>{msg}</Typography>
          </div>
        </div>
      </div>
    )
  }
}
export default withStyles(styles)(NoPropertyFound)



// WEBPACK FOOTER //
// ./src/components/NoPropertyFound.js